import { setIsLoading, setSuccess, setError } from './journey-data-slice';
import { sendJourneyData } from 'api/journey-data';
import { getErrors } from 'api/client';

export const sendJourneyDataThunk = (payload) => async (dispatch) => {
  try {
    dispatch(setIsLoading());
    const response = await sendJourneyData(payload);
    dispatch(setSuccess(response));

    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
